import React from 'react';
import { XAxis, YAxis } from 'react-stockcharts/lib/axes';
import { MouseCoordinateY } from 'react-stockcharts/lib/coordinates';

interface IProps {
	axisAt: string;
	chartDesignConfig: any;
	xTicks: number;
	yTicks: number;
	tickFormat: (d: number) => void;
}

const ChartAxis: React.FC<IProps> = (props) => {
	const { axisAt, chartDesignConfig, xTicks, yTicks, tickFormat } = props;
	return (
		<>
			<YAxis
				axisAt={axisAt}
				orient={axisAt}
				ticks={yTicks}
				zoomEnabled={true}
				tickFormat={tickFormat}
				fontSize={12}
			/>
			<XAxis
				axisAt='bottom'
				orient='bottom'
				ticks={xTicks}
				zoomEnabled={true}
				fontSize={12}
			/>
			<g className={`${axisAt === 'right' ? 'right' : 'left'}`}>
				<MouseCoordinateY
					at={axisAt}
					orient={axisAt}
					fontSize={12}
					displayFormat={tickFormat}
					rectWidth={chartDesignConfig.rectWidth}
					rectHeight={chartDesignConfig.rectHeight}
				/>
			</g>
		</>
	);
};

export default ChartAxis;